import { DataKeyValueStringInterface } from 'pf-frontend-common/src/module/data/key-value/string.interface';
import { JsonApiPayloadInterface } from 'pf-frontend-common/src/module/json-api/payload.interface';
import { ApiServiceInterface } from 'pf-frontend-common/src/service/api/service.interface';

import { EmailAlertAdditionalParamsInterface } from 'common/data/email-alert/additional-params.interface';
import { LocationTypeEnum } from 'common/data/location/type.enum';
import { PropertyModel } from 'common/data/property/model';
import { objectFilterNonOrEmptyValue } from 'common/helper/object/filter/non-or-empty-value';
import { ApiEndpointServiceInterface } from 'common/service/api-endpoint/service.interface';
import { EmailAlertStoreServiceInterface } from 'common/service/email-alert-store/service.interface';

import { EmailAlertModel } from './model';
import { EmailAlertStoreCreateResponseInterface } from './store/create/response.interface';

export class EmailAlertStore implements EmailAlertStoreServiceInterface {
  /**
   * API endpoint
   */
  protected endpoint: { [key: string]: DataKeyValueStringInterface } = {
    create: {
      path: this.apiEndpointService.getPath('/email-alert'),
      method: 'POST',
    },
  };

  /**
   * Additional params from referer
   */
  protected additionalParams: EmailAlertAdditionalParamsInterface = {};

  /**
   * Constructor
   */
  constructor(protected apiService: ApiServiceInterface, protected apiEndpointService: ApiEndpointServiceInterface) {}

  /**
   * @inheritDoc
   */
  public setAdditionalParams(params: EmailAlertAdditionalParamsInterface): void {
    this.additionalParams = params;
  }

  /**
   * @inheritDoc
   */
  public create(model: EmailAlertModel): Promise<EmailAlertStoreCreateResponseInterface> {
    // Prepare path
    const path = this.endpoint.create.path;

    // Prepare payload
    const payload: JsonApiPayloadInterface = model.serialize();

    return this.apiService.request(this.endpoint.create.method, path, objectFilterNonOrEmptyValue(payload), true);
  }

  /**
   * @inheritDoc
   */
  public createModelFromProperty(email: string, data: PropertyModel): EmailAlertModel {
    if (!data) {
      throw new Error(`Can't create EmailAlertModel - PropertyModel undefined`);
    }

    const model = new EmailAlertModel();

    model.email = email;

    if (data.category_id) {
      model.category_ids.push(parseInt(data.category_id, 10));
    }

    if (data.property_type) {
      model.type_id = parseInt(data.property_type.id, 10);
    }

    // Add the last location in the location tree
    if (Array.isArray(data.location_tree) && data.location_tree.length) {
      let lastLocation = data.location_tree[data.location_tree.length - 1];

      if (lastLocation.location_type.toUpperCase() === LocationTypeEnum.tower && data.location_tree.length >= 2) {
        // Can't set location_id of 'TOWER', so use the location before it
        lastLocation = data.location_tree[data.location_tree.length - 2];
      }

      model.location_ids = [parseInt(lastLocation.id, 10)];
    }

    Object.assign(model, this.additionalParams);

    return model;
  }
}
